import {Injectable} from '@angular/core';
import {Benutzer} from '@pezi/entities';
import {SessionStore} from './session.store';
import {select} from "@ngneat/elf";
import {toBoolean} from "@app/core/util/check.util";

@Injectable({ providedIn: 'root' })
export class SessionQuery {

  isLoggedIn$ = this.store.data.pipe(select(sessionStore => toBoolean(sessionStore.loggedInUser)));
  staticServerUrl$ = this.store.data.pipe(select(sessionStore => toBoolean(sessionStore.staticServerUrl)));
  currentUser$ = this.store.data.pipe(select(sessionStore => sessionStore.loggedInUser));

  constructor(protected store: SessionStore) {
  }

  isLoggedIn() {
    return toBoolean(this.store.data.getValue().loggedInUser);
  }

  getLoggedInUser(): Benutzer {
    return this.store.data.getValue().loggedInUser;
  }

}
